import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../molecules/Table/Table';
import { PackageInfoTableProps } from './PackageInfoTable.types';

export const PackageInfoTable = ({
  packageName,
  packageFormat,
  latestVersion,
  fileSize,
  latestRelease,
  microcopy,
  className,
}: PackageInfoTableProps) => {
  return (
    <Table className={className} role="presentation">
      <TableCaption>{microcopy.title}</TableCaption>

      <TableHeader className="sr-only">
        <TableRow>
          <TableHead>{microcopy.headerColumn1}</TableHead>
          <TableHead>{microcopy.headerColumn2}</TableHead>
        </TableRow>
      </TableHeader>

      <TableBody variant="alternate">
        <TableRow>
          <TableHead scope="row">{microcopy.packageName}</TableHead>
          <TableCell>{packageName}</TableCell>
        </TableRow>
        <TableRow>
          <TableHead scope="row">{microcopy.packageFormat}</TableHead>
          <TableCell>{packageFormat}</TableCell>
        </TableRow>
        <TableRow>
          <TableHead scope="row">{microcopy.latestVersion}</TableHead>
          <TableCell>{latestVersion}</TableCell>
        </TableRow>
        {fileSize && (
          <TableRow>
            <TableHead scope="row">{microcopy.fileSize}</TableHead>
            <TableCell>{fileSize}</TableCell>
          </TableRow>
        )}
        <TableRow>
          <TableHead scope="row">{microcopy.latestRelease}</TableHead>
          <TableCell>{latestRelease}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
